import React, {useMemo} from "react";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../utils/ag-grid-columns-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {garrisonLinkUrl} from "../utils/garrison-utils.js";
import GarrisonLink from "./garrison-link.jsx";

const GarrisonDispatchTable = ({rows = [], boName}) => {
    const navigate = navigateHook();

    const columnDefs = useMemo(() => [
        {field: "numberCheckbook", headerName: "Talão", width: 130, comparator: aggridUtils.agGridNumberYearComparator,
            cellRenderer: ({data, value}) => (<GarrisonLink to={garrisonLinkUrl.dispatch(data?.id)} navigate={navigate}>{value ?? ""}</GarrisonLink>),
        },
        {field: "occurrenceNumber", headerName: boName, flex: 1, comparator: aggridUtils.agGridNumberYearComparator,
            cellRenderer: ({data, value}) => (<GarrisonLink to={garrisonLinkUrl.bo(data?.occurrenceNumber)} navigate={navigate}>{value ?? ""}</GarrisonLink>),
        },
        {field: "start", headerName: "Início", width: 150, comparator: aggridUtils.agGridCompareDateTime},
        {field: "end", headerName: "Fim", width: 150, comparator: aggridUtils.agGridCompareDateTime},
        {field: "nature", headerName: "Natureza", flex: 1},
        {field: "place", headerName: "Local pré-cadastrado", flex: 1},
        {field: "neighborhood", headerName: "Bairro", flex: 1},
        {field: "street", headerName: "Logradouro", flex: 1},
        {field: "number", headerName: "Nº", width: 90},
    ], [boName, navigate]);

    return (
        <AgGridReact
            domLayout="autoHeight"
            rowData={rows}
            columnDefs={columnDefs}
            defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            theme={aggridUtils.generalTheme()}
            overlayNoRowsTemplate="Nenhum registro."
        />
    );
};

export default GarrisonDispatchTable;
